import React from 'react';
import { ESTADOS_JUSTO, TIPO_LABEL } from '@/lib/justo';
import { formatFechaHora } from '@/lib/recuentos';
import { ExportJustoButton } from '@/components/ExportJustoButton';

export const EnvioRow = ({ e, onChanged, selectable, selected, onToggle }) => (
  <tr className={`border-t ${e.exportable ? '' : 'opacity-60'}`} data-testid={`justo-envio-row-${e.id}`}>
    {selectable && (
      <td className="px-3 py-2">
        <input type="checkbox" disabled={!e.exportable} checked={selected} onChange={onToggle} className="w-4 h-4 accent-orange-500" data-testid={`justo-envio-check-${e.id}`} />
      </td>
    )}
    <td className="px-3 py-2 font-semibold text-slate-800">N° {e.numero}</td>
    <td className="px-3 py-2 text-slate-600">{formatFechaHora(e.fecha)}</td>
    <td className="px-3 py-2"><div className="text-slate-800">{e.location_name}</div><div className="text-[11px] text-slate-400">{TIPO_LABEL[e.tipo]} · {e.total_items} productos{e.orders_detail?.length ? ` · ${e.orders_detail.map((o) => o.maestro).join(', ')}` : ''}</div></td>
    <td className="px-3 py-2 text-slate-600 text-xs">{e.destino_nombre || <span className="text-slate-400">{e.motivo_no_exporta}</span>}</td>
    <td className="px-3 py-2">
      {e.exportable && <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${ESTADOS_JUSTO[e.estado_justo]?.className}`}>{ESTADOS_JUSTO[e.estado_justo]?.label}</span>}
      {e.justo_export && <div className="text-[11px] text-slate-400 mt-0.5">{e.justo_export.exportado_por} · {formatFechaHora(e.justo_export.fecha_exportacion)}</div>}
    </td>
    <td className="px-3 py-2 text-right">{(e.exportable || e.motivo_no_exporta?.includes('bodega de origen')) && <ExportJustoButton tipo={e.tipo} id={e.id} onChanged={onChanged} />}</td>
  </tr>
);

export const EnviosTable = ({ envios, onChanged, selectable, selected = {}, onToggle, onToggleAll }) => (
  <div className="bg-white rounded-xl border overflow-x-auto">
    <table className="w-full text-sm" data-testid="justo-envios-table">
      <thead className="bg-slate-50 text-slate-600">
        <tr>
          {selectable && <th className="px-3 py-2"><input type="checkbox" onChange={onToggleAll} className="w-4 h-4 accent-orange-500" data-testid="justo-envios-check-all" /></th>}
          <th className="px-3 py-2 text-left">N°</th>
          <th className="px-3 py-2 text-left">Fecha</th>
          <th className="px-3 py-2 text-left">Local TUPU</th>
          <th className="px-3 py-2 text-left">Destino Justo</th>
          <th className="px-3 py-2 text-left">Estado</th>
          <th className="px-3 py-2" />
        </tr>
      </thead>
      <tbody>
        {envios.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-slate-400">Sin envíos</td></tr>}
        {envios.map((e) => (
          <EnvioRow key={e.id} e={e} onChanged={onChanged} selectable={selectable}
            selected={!!selected[e.id]} onToggle={() => onToggle(e)} />
        ))}
      </tbody>
    </table>
  </div>
);
